import {
  PageHeader,
  PageHeaderActions,
  PageHeaderTitle,
  PageHeaderTop,
  Text,
  csx,
} from '@vtex/admin-ui'
import { useIntl } from 'react-intl'
import type { CalculatorType } from 'typings'
import { useFormStateContext } from 'ui'
import { PromotionIcon } from '../../PromotionIcon'
import { promotionTypeMessages } from '../../utils/promotionTypes'
import { HeaderActionMenu } from './ActionMenu'
import { ArchivedPromotionHeaderButtons } from './ArchivedButtons'
import { ActivePromotionHeaderButtons } from './Buttons'
import { Feedback } from './Feedback'

export function Header() {
  const { formatMessage } = useIntl()

  const { originalValues, readOnly, form } = useFormStateContext()

  const archived = readOnly
  const isNew = !originalValues

  const type: CalculatorType = form.getValues('type')

  const name =
    originalValues?.name ??
    formatMessage({ id: 'admin/promotions.form.new-promotion' })

  return (
    <PageHeader>
      <PageHeaderTop>
        <PromotionIcon
          type={type}
          className={csx({ marginRight: '$space-5' })}
        />

        <PageHeaderTitle
          className={csx({
            flex: '1',
            minWidth: 0,
            paddingRight: '$space-5',
            div: {
              display: 'block',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            },
          })}
        >
          {name}

          <Text tone="secondary" className={csx({ display: 'block' })}>
            {formatMessage(promotionTypeMessages[type])}
          </Text>
        </PageHeaderTitle>

        <PageHeaderActions>
          <Feedback />
          {archived ? (
            <ArchivedPromotionHeaderButtons />
          ) : (
            <ActivePromotionHeaderButtons />
          )}

          {!isNew && <HeaderActionMenu />}
        </PageHeaderActions>
      </PageHeaderTop>
    </PageHeader>
  )
}
